
                import Dic from 'services/dictionary';
                Dic.addWord('wt_all__notification__common_error__btn_update', {"en":"Update","ru":"Обновить"});
            